import { dateFormat } from '@app/constants'

import type { LntDatePickerProps } from '@app/components/base/Form/Input/DatePicker/types'

export const weekSelectFormat: LntDatePickerProps['format'] = value => {
  return `${value.format(dateFormat.W)} неделя`
}
